import classroomImage from '../images/liskov-journey/classroom-animals.png'

const ClassroomImage = () => {
    return (
        <div className='classroom-image-component'>
            <img src={classroomImage} alt="Liskov classroom in cartoon form" />
        </div>
    );
};

export default ClassroomImage;